/*
 * Publication Page Messages
 *
 * This contains all the text for the Publication Page components.
 */

import { defineMessages } from 'react-intl';

const scope = 'app.workspace.publications';

export default defineMessages({
  add: {
    id: `${scope}.add`,
    defaultMessage: 'Add',
  },
  defaultProjectName: {
    id: `${scope}.default.projectName`,
    defaultMessage: 'Untitled activity',
  },
  name: {
    id: `${scope}.name`,
    defaultMessage: 'Course',
  },
  selectCourseware: {
    id: `${scope}.selectCourseware`,
    defaultMessage: 'Select Courseware',
  },
  moveCourseware: {
    id: `${scope}.moveCourseware`,
    defaultMessage: 'Move Courseware',
  },
  duplicateCourseware: {
    id: `${scope}.duplicateCourseware`,
    defaultMessage: 'Duplicate Courseware',
  },
  owner: {
    id: `${scope}.owner`,
    defaultMessage: 'PUBLISHED BY',
  },
  updatedAt: {
    id: `${scope}.updatedAt`,
    defaultMessage: 'Last Modified',
  },
  selectProject: {
    id: `${scope}.selectProject`,
    defaultMessage: 'Select Project',
  },
  publishAllCaps: {
    id: `${scope}.publishAllCaps`,
    defaultMessage: 'PUBLISH',
  },
  publish: {
    id: `${scope}.publish`,
    defaultMessage: 'Publish',
  },
  publishClassOnDemand: {
    id: `${scope}.publishClassOnDemand`,
    defaultMessage: 'Publish Class On Demand',
  },
  publishPearsonPlus: {
    id: `${scope}.publishClassOnDemand`,
    defaultMessage: 'Publish Pearson +',
  },
  publishPearsonPlusTest: {
    id: `${scope}.bvTestOnly`,
    defaultMessage: 'Publish BV-Test Only',
  },
  publishInDesign: {
    id: `${scope}.publishInDesign`,
    defaultMessage: 'Publish InDesign',
  },
  status: {
    id: `${scope}.status`,
    defaultMessage: 'STATUS',
  },
  completed: {
    id: `${scope}.completed`,
    defaultMessage: 'COMPLETED',
  },
  searchCourseware: {
    id: `${scope}.searchCourseware`,
    defaultMessage: 'Search courseware',
  },
  searchProject: {
    id: `${scope}.searchProject`,
    defaultMessage: 'Search project',
  },
  selectUnit: {
    id: `${scope}.selectUnit`,
    defaultMessage: 'Select Unit',
  },
  searchUnit: {
    id: `${scope}.searchUnit`,
    defaultMessage: 'Search unit',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
  backButton: {
    id: `${scope}.backButton`,
    defaultMessage: 'Back',
  },
  nextButton: {
    id: `${scope}.nextButton`,
    defaultMessage: 'Next',
  },
  moveButton: {
    id: `${scope}.moveButton`,
    defaultMessage: 'Move',
  },
  duplicateButton: {
    id: `${scope}.moveButton`,
    defaultMessage: 'Duplicate',
  },
  addButton: {
    id: `${scope}.addButton`,
    defaultMessage: 'Add',
  },
  outputInfoDoneButton: {
    id: `${scope}.outputInfoDoneButton`,
    defaultMessage: 'Done',
  },
  outputInfo: {
    id: `${scope}.outputInfo`,
    defaultMessage: 'Output Info',
  },
  emptyStateMessage: {
    id: `${scope}.emptyStateMessage`,
    defaultMessage: 'No content found',
  },
  selectMessage: {
    id: `${scope}.selectMessage`,
    defaultMessage: 'Select',
  },
  titleMessage: {
    id: `${scope}.titleMessage`,
    defaultMessage: 'Find your content',
  },
  contentMessage: {
    id: `${scope}.contentMessage`,
    defaultMessage: 'Content Info',
  },
  EPUB_ETEXT: {
    id: `${scope}.epub`,
    defaultMessage: 'Pearson+ ePub',
  },
  EPUB_CHANNEL_PARTNER: {
    id: `${scope}.channelPartner`,
    defaultMessage: 'Channel Partner ePub',
  },
  BRONTE_CLASSES_ON_DEMAND: {
    id: `${scope}.classOnDemand`,
    defaultMessage: 'Mastering iLabs',
  },
  BRONTE_PEARSON_PLUS: {
    id: `${scope}.pearsonPlus`,
    defaultMessage: 'Pearson+ Bronte Viewer',
  },
  BRONTE_PEARSON_PLUS_TEST_ONLY: {
    id: `${scope}.pearsonPlusTest`,
    defaultMessage: 'BV-Test Only',
  },
  IN_DESIGN: {
    id: `${scope}.InDesign`,
    defaultMessage: 'InDesign',
  },
  accessibilityNote: {
    id: `${scope}.accessibilityNote`,
    defaultMessage: 'Select landmarks for accessibility',
  },
  note: {
    id: `${scope}.note`,
    defaultMessage: 'Note',
  },
  publishComment: {
    id: `${scope}.publishComment`,
    defaultMessage: 'Enter comment for publishing',
  },
  typeFeedback: {
    id: `${scope}.typeFeedback`,
    defaultMessage: 'Please select a type',
  },
  noteFeedback: {
    id: `${scope}.noteFeedback`,
    defaultMessage: 'Please add a note',
  },
  publishCardInfo: {
    id: `${scope}.pubCardInfo`,
    defaultMessage: 'Before you publish, don’t forget to:',
  },
  publishCardInfoUpdate: {
    id: `${scope}.pubCardInfoUpdate`,
    defaultMessage: 'Update Author',
  },
  publishCardInfoGenerateId: {
    id: `${scope}.pubCardInfoGenerateId`,
    defaultMessage: 'Genereate ID from Mastering',
  },
  publishCardInfoRefresh: {
    id: `${scope}.pubCardInfoRefresh`,
    defaultMessage: 'Refresh assets',
  },
  format: {
    id: `${scope}.format`,
    defaultMessage: 'Format',
  },
  findContent: {
    id: `${scope}.format`,
    defaultMessage: 'Find your content',
  },
  contentInfo: {
    id: `${scope}.contentInfo`,
    defaultMessage: 'Content info',
  },
  bronteProjectName: {
    id: `${scope}.bronteProjectName`,
    defaultMessage: 'Bronte project name',
  },
  author: {
    id: `${scope}.author`,
    defaultMessage: 'Author',
  },
  warning: {
    id: `${scope}.warning`,
    defaultMessage:
      'Please don’t close this window or refresh this page until the upload is finished.',
  },
  uploadCompleted: {
    id: `${scope}.uploadCompleted`,
    defaultMessage: 'Upload completed',
  },
  uploadFailed: {
    id: `${scope}.uploadFailed`,
    defaultMessage:
      'Upload interrupted by a network error. Check you connection or keep your computer active.',
  },
  publishTitle: {
    id: `${scope}.publishTitle`,
    defaultMessage: 'Publish',
  },
  exportTitle: {
    id: `${scope}.exportTitle`,
    defaultMessage: 'Exporting Publication',
  },
  landmarkInfo: {
    id: `${scope}.landmarkInfo`,
    defaultMessage: 'Landmarks help readers using assistive technology navigate the ebook. Most landmarks are generated automatically. Brief content, start of content, and backmatter need to be selected manually.',
  },
  publishType: {
    id: `${scope}.publishType`,
    defaultMessage: 'Publish type',
  },
  releaseForLive: {
    id: `${scope}.releaseForLive`,
    defaultMessage: 'Release For Live',
  },
  releaseForReview: {
    id: `${scope}.releaseForReview`,
    defaultMessage: 'Release for Review (QA)',
  },
  minorContentUpdate: {
    id: `${scope}.minorContentUpdate`,
    defaultMessage: 'Minor Content Update',
  },
  majorContentUpdate: {
    id: `${scope}.majorContentUpdate`,
    defaultMessage: 'Major Content Update',
  },
  authorFeedback: {
    id: `${scope}.authorFeedback`,
    defaultMessage: 'Please update course with a Valid Author name',
  },
  outputSelectTitle: {
    id: `${scope}.outputSelectTitle`,
    defaultMessage: 'Choose output type',
  },
  marketSelectTitle: {
    id: `${scope}.marketSelectTitle`,
    defaultMessage: 'Choose market',
  },
  contentInfoTitle: {
    id: `${scope}.contentInfoTitle`,
    defaultMessage: 'Content info',
  },
  ok: {
    id: `${scope}.ok`,
    defaultMessage: 'OK',
  },
  unauthorizedMessage: {
    id: `${scope}.unauthorizedMessage`,
    defaultMessage: 'You have to be an owner of the project in order to perform this action',
  },
  publicationAlertMessage: {
    id: `${scope}.publicationAlertMessage`,
    defaultMessage: 'The theme you\'ve applied in Bronte will be replaced for a CP-specific Theme',
  },
  isbn: {
    id: `${scope}.isbn`,
    defaultMessage: 'Parent ISBN',
  },
  isbnPlaceholder: {
    id: `${scope}.isbnPlaceholder`,
    defaultMessage: 'Enter parent ISBN',
  },
  childisbn: {
    id: `${scope}.childisbn`,
    defaultMessage: 'Channel Partner ISBN',
  },
  childIsbnPlaceholder: {
    id: `${scope}.childIsbnPlaceholder`,
    defaultMessage: 'Enter Channel Partner ISBN',
  },
  isbnValidationLable: {
    id: `${scope}.isbnValidationLable`,
    defaultMessage: 'ISBN validation',
  },
  isbnCheckLable: {
    id: `${scope}.isbnCheckLable`,
    defaultMessage: 'Skip PDH validation',
  },
  validationEnabledLable: {
    id: `${scope}.validationEnabledLable`,
    defaultMessage: 'Skip epub validation',
  },
  validationText: {
    id: `${scope}.validationText`,
    defaultMessage: 'Manually validate your epub. Only for review PDF generation',
  },
  isbnCheckText: {
    id: `${scope}.isbnCheckText`,
    defaultMessage: 'Manually validate the ISBN. Only for single ISBN CP ePubs',
  },
  isbnFeedback: {
    id: `${scope}.isbnFeedback`,
    defaultMessage: 'Please enter the ISBN',
  },
  productId: {
    id: `${scope}.productId`,
    defaultMessage: 'Product ID',
  },
  sharedKey: {
    id: `${scope}.sharedKey`,
    defaultMessage: 'Shared key',
  },
  sharedSecret: {
    id: `${scope}.sharedSecret`,
    defaultMessage: 'Shared secret',
  },
  productIdPlaceholder: {
    id: `${scope}.productIdPlaceholder`,
    defaultMessage: 'Enter product id',
  },
  productIdFeedback: {
    id: `${scope}.productIdFeedback`,
    defaultMessage: 'You must enter a product ID',
  },
  productIdDuplicateFeedback: {
    id: `${scope}.productIdDuplicateFeedback`,
    defaultMessage: 'Product ID must be unique',
  },
  discipline: {
    id: `${scope}.discipline`,
    defaultMessage: 'Discipline',
  },
  disciplinePlaceholder: {
    id: `${scope}.disciplinePlaceholder`,
    defaultMessage: 'Enter discipline',
  },
  disciplineFeedback: {
    id: `${scope}.disciplineFeedback`,
    defaultMessage: 'Please select a discipline',
  },
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Title',
  },
  titlePlaceholder: {
    id: `${scope}.titlePlaceholder`,
    defaultMessage: 'Enter title',
  },
  description: {
    id: `${scope}.description`,
    defaultMessage: 'Description',
  },
  descriptionPlaceholder: {
    id: `${scope}.descriptionPlaceholder`,
    defaultMessage: 'Enter description',
  },
  estimatedTime: {
    id: `${scope}.estimatedTime`,
    defaultMessage: 'Estimated Time',
  },
  estimatedTimePlaceholder: {
    id: `${scope}.estimatedTimePlaceholder`,
    defaultMessage: 'Enter estimated time',
  },
  previewUrl: {
    id: `${scope}.previewUrl`,
    defaultMessage: 'Preview URL',
  },
  previewUrlPlaceholder: {
    id: `${scope}.previewUrlPlaceholder`,
    defaultMessage: 'Enter preview URL',
  },
  previewUrlFeedback: {
    id: `${scope}.previewUrlFeedback`,
    defaultMessage: 'You must enter preview URL',
  },
  modalTitleForEntry: {
    id: `${scope}.modalTitleForEntry`,
    defaultMessage: 'Publish',
  },
  modalTitleForBrief: {
    id: `${scope}.modalTitleForBrief`,
    defaultMessage: 'Choose the brief contents',
  },
  modalTitleForStart: {
    id: `${scope}.modalTitleForStart`,
    defaultMessage: 'Choose the start of content',
  },
  modalTitleForBackmatter: {
    id: `${scope}.modalTitleForBackmatter`,
    defaultMessage: 'Choose the backmatter',
  },
  deleteVersion: {
    id: `${scope}.deleteVersion`,
    defaultMessage: 'Delete this Version',
  },
  deleteItem: {
    id: `${scope}.deleteItem`,
    defaultMessage: 'DELETE',
  },
  deleteConfirmText: {
    id: `${scope}.deleteConfirmText`,
    defaultMessage: 'You will not be able to recover this version once deleted. Are you sure you want to continue?',
  },
  aAndB: {
    id: `${scope}.aAndB`,
    defaultMessage: 'A and P',
  },
  astronomy: {
    id: `${scope}.astronomy`,
    defaultMessage: 'Astronomy',
  },
  biology: {
    id: `${scope}.biology`,
    defaultMessage: 'Biology',
  },
  chemistry: {
    id: `${scope}.chemistry`,
    defaultMessage: 'Chemistry',
  },
  engineering: {
    id: `${scope}.engineering`,
    defaultMessage: 'Engineering',
  },
  environmentalScience: {
    id: `${scope}.environmentalScience`,
    defaultMessage: 'Environmental Science',
  },
  microbiology: {
    id: `${scope}.microbiology`,
    defaultMessage: 'Microbiology',
  },
  physics: {
    id: `${scope}.physics`,
    defaultMessage: 'Physics',
  },
  organizationalLevel: {
    id: `${scope}.organizationalLevel`,
    defaultMessage: 'Organizational Level',
  },
  tocFeedback: {
    id: `${scope}.tocFeedback`,
    defaultMessage: 'Please select a level',
  },
});
